import { Form } from 'react-bootstrap';
import { inputTypes } from '../../../constants/strings';

// Registry of question inputTypes that PREFILL_ANSWER can target. Each entry defines:
//   - renderConfigFields: the authoring-UI inputs used to define the predetermined value,
//     returning the additionalData shape to save via onChange.
//   - isAlreadyApplied: given the target question's current raw answer value, a candidate
//     ({ label, data }), and the target question itself, whether that candidate is already
//     reflected in the answer (dedup).
// To support prefilling another question type later, add a key here — no other file needs
// to know about the new type; the authoring picker and runtime trigger evaluation both read
// from this registry's keys rather than checking inputType directly.
export const prefillTargetTypes = {
  [inputTypes.table]: {
    renderConfigFields: (targetQuestion, value, onChange) => {
      const columns = targetQuestion?.additionalData?.split('|') ?? [];
      return columns.map((column) => (
        <Form.Control
          key={column}
          placeholder={column}
          type="text"
          as="textarea"
          rows="2"
          value={value?.columns?.[column] ?? ''}
          onChange={({ target: { value: cellValue } }) =>
            onChange({ columns: { ...value?.columns, [column]: cellValue } })
          }
        />
      ));
    },
    isAlreadyApplied: (currentValue, candidate, targetQuestion) => {
      if (!currentValue || typeof currentValue !== 'string') return false;
      const columns = targetQuestion?.additionalData?.split('|') ?? [];
      const candidateColumns = candidate?.data?.columns ?? {};
      // Whichever columns the author actually configured a value for (not just the
      // first one — a table's identifying column isn't necessarily column 1, and a
      // blank first column shouldn't make every candidate look "never applied").
      const configuredColumns = columns.filter(
        (column) => candidateColumns[column],
      );
      if (!configuredColumns.length) return false;
      const rows = currentValue.split('|').map((row) => row.split('\n'));
      return rows.some((rowCells) =>
        configuredColumns.every((column) => {
          const columnIndex = columns.indexOf(column);
          return rowCells[columnIndex] === candidateColumns[column];
        }),
      );
    },
  },
};
